export class NewsModel{
    id: number;
    name: string;
    short_description: string;
    description: string;
    news_photo_link: string;
    date: string;
}